import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from "@material-ui/core";

import CircleCheckedFilled from "@material-ui/icons/RadioButtonChecked";
import CircleUnchecked from "@material-ui/icons/RadioButtonUnchecked";

import Analytics from "../../../../../../helpers/analytics";
import selectRMuser from "../../../../../../redux/reselect/cart/selectRMuser";

const ProductSelector = (props) => {
  const {
    products,
    video,
    cartContents,
    addToCart,
    submitting,
    submittingState,
  } = props;

  const [selected, setSelected] = useState("");

  const isRMuser = selectRMuser(props.auth);
  const isInCart = cartContents.find((item) => item.id === video.jmId);

  const onClickAddToCart = () => !isRMuser && addToCart();

  const onClickSelectProduct = (item) => {
    if (!Boolean(isInCart)) {
      if (item.title !== selected) {
        setSelected(item.title);
        document.getElementById(item.variants[0].id).checked = true;
      } else {
        setSelected("");
        document.getElementById(item.variants[0].id).checked = false;
      }
    }
  };

  const EDITORIAL = products.filter((item) => item.productType === "Editorial");

  return (
    <div className={isRMuser ? "RMuser" : ""}>
      <section className="shopify-packages">
        <div
          className={classnames("accordion productSelector")}
          id="packagesGroup"
        >
          <span className="product--message">
            For Digital Publishers Only <br/>i.e., fan engagement on social media, websites, and blogs, or for educational use
          </span>
          <span
            className="product--compare"
            role="link"
            onClick={() => {
              Analytics.track("Compare Packages", {
                category: "LP-VideoDetail",
                label: "Digital",
              });
              props.openDigitalTermModal();
            }}
          >
            Which license do I need?
          </span>

          {EDITORIAL.map((item, index) => (
            <div className="shopify-item" key={String(index)}>
              <h3 href={`#ShopifyChoices${index}`} className="collapsed">
                <input
                  type="radio"
                  name="shopify-choices"
                  id={item.variants[0].id}
                  value={item.variants[0].id}
                  data-price={item.variants[0].price.amount}
                  data-product-type={item.productType}
                  data-product-name={item.title}
                  defaultChecked={isInCart}
                  readOnly={isInCart}
                />
                <FormGroup classes={{ root: "product__label" }}>
                  <FormControlLabel
                    label={
                      <div>
                        <div className="label--value">
                          <span>{item.title}</span>
                          <span>${item.variants[0].price.amount}</span>
                        </div>
                      </div>
                    }
                    control={
                      <Checkbox
                        color="default"
                        checked={
                          (Boolean(isInCart) &&
                            isInCart.productName === item.title) ||
                          selected === item.title
                        }
                        disabled={isRMuser}
                        icon={<CircleUnchecked />}
                        checkedIcon={<CircleCheckedFilled />}
                      />
                    }
                    onChange={() => onClickSelectProduct(item)}
                  />
                  <FormHelperText classes={{ root: "discount--text" }}>
                    {item.title.toUpperCase() === "PERSONAL" && (
                      <span>Discounts as low as $39</span>
                    )}

                    {item.title.toUpperCase() === "BASIC PRO" && (
                      <span>Discounts as low as $110</span>
                    )}

                    {item.title.toUpperCase() === "SUPER PRO" && (
                      <span>Discounts as low as $209</span>
                    )}
                  </FormHelperText>
                </FormGroup>
              </h3>
            </div>
          ))}
        </div>
        <a href="/licensing/pricing" className="go--to--pricing">
          Learn more about discount packs
        </a>
      </section>

      {/* The Add to Cart Button with SVG animation*/}
      <section className="addToCart">
        <button
          className={classnames("cartButton add-to-cart-button", {
            disabled: Boolean(isInCart) || !Boolean(selected),
          })}
          disabled={
            (submittingState && submitting) ||
            Boolean(isInCart) ||
            !Boolean(selected)
          }
          onClick={onClickAddToCart}
        >
          <span className="button--text">Add to Cart</span>
          <svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32">
            <path
              strokeDasharray="19.79 19.79"
              strokeDashoffset="19.79"
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="2"
              strokeLinecap="square"
              strokeMiterlimit="10"
              d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"
            />
          </svg>
        </button>
      </section>
    </div>
  );
};

ProductSelector.propTypes = {
  className: PropTypes.string,
  products: PropTypes.array,
  cartContents: PropTypes.array,
  video: PropTypes.object,
  openTermModal: PropTypes.func,
  addToCart: PropTypes.func,
};

export default ProductSelector;
